export enum TimelineChangeType {
	Discovered = 'discovered',
	Modified = 'modified',
	Vanished = 'vanished'
}
